import { render } from "./RMDownloadDialog.vue?vue&type=template&id=2fbec2d0&scoped=true"
import script from "./RMDownloadDialog.vue?vue&type=script&lang=js"
export * from "./RMDownloadDialog.vue?vue&type=script&lang=js"

import "./RMDownloadDialog.vue?vue&type=style&index=0&id=2fbec2d0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fbec2d0"]])

export default __exports__